<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
      p.text-center 在每一屆 WirForce 中，我們都會訂立些指標性的成就，為了記錄這些歷經艱辛留名 WirForce 歷史的勇者們，我們以崇敬的心將他們銘刻在這「榮譽英雄牆」上，讓世人傳唱勇者們的榮譽事蹟……這些獎項看似惡搞，卻都存在著團隊合作、自律管理、以及挑戰自我的理念，也代表了現場所有參與的 BYOC 玩家精神

    .mb-5
    section
      //- .tab-wrap
        .tab-item(v-for="tab in tabs", @click="tabScroll(tab.offsetTop)") {{ tab.name }}
    .mb-10
    section
      .section-title 2017
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 大會成就獎
        img(src="~assets/hero/hero1701.png")
      .paragraph-wrap
        .em-title
          .icon-logo
          .text Fight 賽事成就獎
        img(src="~assets/hero/hero1702.png")
      .paragraph-wrap
        .em-title
          .icon-logo
          .text 活動成就獎
        img(src="~assets/hero/hero1703.png")
    section
      .section-title 2016
      .paragraph-wrap
        .em-title
          .icon-logo
          .text WirForce 2016 大會成就獎
        img(src="~assets/hero/hero01.png")
      .paragraph-wrap
        .em-title
          .icon-logo
          .text WirForce 2016 BYOC 社群活動成就獎
        img(src="~assets/hero/hero02.png")
    section
      .section-title 2015
      .paragraph-wrap
        .em-title
          .icon-logo
          .text WirForce 2015 特殊成就
        img(src="~assets/hero/hero03.png")
    section
      .section-title 2014
      .paragraph-wrap
        .em-title
          .icon-logo
          .text WirForce 2014 現場賽事
        img(src="~assets/hero/hero04.png")
      .paragraph-wrap
        .em-title
          .icon-logo
          .text WirForce 2014 特殊成就
        img(src="~assets/hero/hero05.png")
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'hero',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
.paragraph-wrap
  .em-title
    margin-bottom: 24px
  img
    max-width: calc(100% - 32px)
    // margin:
      // left: 32px
      // bottom: 32px
    margin: 32px auto
    display: block
</style>



// WEBPACK FOOTER //
// hero.vue?262f362d